const attributes = {
  toast: {
    error: {
      badResponse: 'erro ao atualizar [Attribute]',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Attribute] foi atualizado com sucesso',
      },
      delete: {
        body: 'Os atributos foram excluídos com sucesso',
      },
    },
  },
  table: {
    headerButtons: {
      create: 'Criar',
      delete: {
        label: 'Remover',
        deleteModal: {
          header: 'Excluir Atributos',
          body: 'Você está prestes a excluir {{attributes}} atributos',
        },
      },
      clear: {
        label: 'Limpar',
        clearModal: {
          header: 'Limpar atributos',
          body: 'Você está prestes a limpar os atributos {{attributes}}',
        },
      },
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    placeholder: {
      select: 'Selecione',
    },
    headers: {
      name: 'Nome',
      labels: 'Etiquetas',
    },
    toolTip: {
      noPermission: 'Ação não permitida: Permissão necessária',
    },
  },
  form: {
    header: {
      createAttribute: {
        title: 'Criar',
      },

      updateAttribute: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },
    information: {
      details: {
        header: 'Informações Gerais',
        fields: {
          name: 'Nome',
          description: 'Descrição',
        },
      },
      aliases: {
        header: 'Mapeamento de Nome de Atributo',
        fields: {
          drivers: 'Motoristas',
          vehicles: 'Veículos',
          bookings: 'Reservas',
        },
      },
      advanced: {
        header: 'Configurações avançadas',
        fields: {
          sharedRideRatio: 'Proporção Máxima de Tempo Partilhado',
          maxSharedDistanceRatio: {
            label: 'Proporção Máxima de Distância Partilhada',
            description: 'Define quanto uma viagem partilhada pode ser mais longa em comparação com a distância a solo. Exemplo: Se a distância a solo é 1 milha e a proporção é 1,2x, a viagem partilhada não pode exceder 1,2 milhas',
          },
          maxSinglePassengerTime: 'Tempo máximo de viagem para um único passageiro',
          maxPassengers: 'Máximo de passageiros',
          maxTripStops: 'Máximo de paradas',
          tripBoardingTime: 'Horário de Embarque',
          tripDropOffTime: 'Horário de Desembarque',
          attributeReassignment: 'Habilitar o Re-Roteamento de Atributo',
          attributeReassignmentDescription:
            'Quando habilitada, essa configuração aciona o reencaminhamento automático de viagens em resposta a atualizações em atributos específicos de reserva. Sem habilitar esta configuração, as alterações de atributos não solicitarão o relés de viagem.',
          matchScore: 'Habilitar a Correspondência de Atributos Motorista/Veículo-Reserva',
          matchScoreDescription:
            'Habilitar esta configuração permite que o sistema considere a correspondência de atributos ao atribuir motoristas/veículos a reservas. Sem habilitar essa configuração, o sistema irá desconsiderar esse atributo ao fazer correspondências motoristas/veículos- reservas.',
          maxBoardingDelay: 'Atraso Máximo no embarque',
          maxBoardingEarly: 'Antecipação Máxima no Embarque',
          maxDropOffEarly: {
            label: 'Adiantamento Máximo na Entrega',
            description:
              'Número máximo de minutos que um motorista pode se adiantar em relação ao horário de desembarque definido na reserva.',
          },
          maxDropOffDelay: {
            label: 'Atraso Máximo na Entrega',
            description:
              'Número máximo de minutos que um motorista pode se atrasar em relação ao horário de desembarque definido na reserva.',
          },
          minScore: 'Pontuação mínima',
          waitAndReturn: 'Aguarde e Retorne',
          waitAndReturnDescription:
            'A duração em minutos que um motorista esperará entre os trajetos de ida e de volta de uma viagem de espera e ida.',
          off: 'Desativado',
          maxPassengerAtOnce: 'Máximo de passageiros de uma só vez',
          maxPickupStops: 'Máximo de Paradas de Recolher',
          maxDropoffStops: 'Máximo de Paradas de Deixar',
          onlyPrivate: 'Apenas privado',
          maxSimultaneousBookings: 'Máximo de Reservas Simultâneas',
          sharedWith: 'Compartilhado com',
          willCallTimeOffset: 'Deslocamento de Tempo do Will Call',
          leg: {
            label:'Habilitar como Trecho',
            description: 'Este trecho já está atribuído a outro atributo.'
          }
        },
      },
    },
    valdations: {
      name: {
        required: 'Campo de nomeação obrigatória',
        name: 'Nome inválido',
      },
      unit: {
        required: 'Requer-se a unidade',
        name: 'Unidade inválida',
      },
      parameters: {
        required: 'Os parâmetros são obrigatórios',
        name: 'Verifique com atenção os valores que você está passando',
      },
    },
    create: {
      toastError: {
        message: 'Não foi possível criar',
      },
      toastSuccess: {
        message: 'Criado com sucesso',
      },
    },

    update: {
      formTabs: {
        generalInfo: 'Geral',
        advanced: 'Configurações avançadas',
        history: 'Histórico',
      },

      toastError: {
        message: 'Não foi possível atualizar',
      },
      toastSuccess: {
        message: 'Atualizado com sucesso',
      },
    },
  },
};

export default attributes;
